<template>
    <div class="events-bg">
        <CalendarPage :mode="mode" />
        <div class="events" v-for="(event, index) in events" :key="index">
            <div class="event-container-item">
                <div class="left-content">
                    <div>
                        <p class="event-date">{{ event.end_date }}</p>
                        <p class="event-budget">
                            <span>Budget</span><br />${{ event.budget }}
                        </p>
                    </div>
                    <div class="d-flex">
                        <div
                            class="event-keywords"
                            v-for="(tag, index) in event.array_keywords"
                            :key="index"
                        >
                            <p>{{ tag }}</p>
                        </div>
                    </div>
                </div>
                <div class="rigth-content">
                    <div class="address-container">
                        <p class="venue-name">{{ event.venue.full_name }}</p>
                        <p class="venue-address">{{ event.city_address }}</p>
                    </div>
                    <div>
                        <button class="apply-btn">Apply</button>
                    </div>
                </div>
            </div>
        </div>
        <UpCommingEventsModal :isVisible.sync="isVisible" v-if="isVisible === 'showModal'" />
    </div>
</template>

<script>
    import axios from 'axios'
    import CalendarPage from './CalendarForm.vue'
    import UpCommingEventsModal from './UpCommingEventsModal.vue'

    export default {
        name: 'UpCommingEventsVenue',
        props: {
            isVisible: {
                type: String,
                default: 'showModal'
            }
        },
        components: {
            CalendarPage,
            UpCommingEventsModal
        },
        data: () => ({
            events: [],
            mode: 'eventsMode'
        }),
        async created() {
            const slug = localStorage.getItem('venueSlug')
            const response = await axios.get('/v1/venues/' + slug + '/show-upcoming-events')
            this.events = response.data.data
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .events-bg {
        background: #b6b6b6;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .events {
        margin-bottom: 90px;
    }
    .event-container-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        padding: 20px;
        gap: 30px;
        width: 1195px;
        background: #ffffff;
        border: 0.5px solid #c4c4c4;
        box-shadow: 0px 4px 6px rgba(101, 100, 100, 0.24);
        border-radius: 20px;
        margin-bottom: 20px;
    }
    .left-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex: 30%;
    }
    .rigth-content {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex: 70%;
    }
    .event-date {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 800;
        font-size: 30px;
        line-height: 37px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #49306b;
    }
    .event-budget {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #49306b;
    }
    .venue-name {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 21px;
        line-height: 24px;
        text-align: right;
        letter-spacing: 3px;
        text-transform: uppercase;
        color: #49306b;
    }
    .venue-address {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 21px;
        line-height: 25px;
        text-align: right;
        letter-spacing: 0.1em;
        color: #434343;
    }
    .address-container {
        margin-bottom: 50px;
    }
    .apply-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 20px;
        gap: 10px;
        min-width: 240px;
        background: #d7eb5a;
        border-radius: 100px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #1b0d29;
        margin-top: 50px;
    }
    .event-keywords {
        display: flex;
        flex-wrap: wrap;
    }
    .event-keywords p {
        padding: 3px 14px;
        border: 1px solid #49306b;
        border-radius: 20px;
        max-width: 150px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right: 12px;
    }
</style>
